import React, { PureComponent, lazy, Suspense } from 'react';

import { Balloon, Icon, Badge, Button, Switch, Feedback } from '@icedesign/base';
import IceImg from '@icedesign/img';
import Layout from '@icedesign/layout';
import Menu from '@icedesign/menu';

import { Link } from 'react-router-dom';

import cx from 'classnames';
import FoundationSymbol from 'foundation-symbol';

import { getAuthority } from '@/auth/authority';
import Auths from '@/auth/Auths';
import RequireAuthority from '@/auth/RequireAuthority';
import KeyConnector from '@/components/KeyConnector';
import { formatMessage } from '@/i18n';
import { resetCustomizationLoaded } from '@/layouts/LayoutHOC';
import { getHeaderMenuConfig } from '@/menuConfig';
import Colors from '@/tool/Colors';
import { isAdvancedTask, isGuest, isWMSdk, isMulti, getProfile } from '@/tool/profile';
import { isWindows, isIE } from '@/tool/tool';

import Logo from './Logo';

import './style.scss';

const FaToolbox = lazy(() => import('react-icons/fa').then(mod => ({ default: mod.FaToolbox })));
const FaPlug = lazy(() => import('react-icons/fa').then(mod => ({ default: mod.FaPlug })));
const FaChevronRight = lazy(() =>
  import('react-icons/fa').then(mod => ({ default: mod.FaChevronRight }))
);
const FaKey = lazy(() => import('react-icons/fa').then(mod => ({ default: mod.FaKey })));

const AuthUserItem = RequireAuthority(UserItem);
const AuthMenuItem = RequireAuthority(Menu.Item);
const AuthCommItem = RequireAuthority(CommItem);

export default class Header extends PureComponent {
  constructor(props) {
    super(props);
    const multi = isMulti();
    if (multi == null) {
      resetCustomizationLoaded();
    }
    this.state = {
      multi,
    };
    this.headerMenuConfig = getHeaderMenuConfig();
  }

  render() {
    // console.log(headerMenuConfig)
    const {
      width,
      theme,
      isMobile,
      className,
      style,
      profileInfo,
      sdkInfo,
      messagesInfo,
      onShowAbout,
      onLogout,
      hideHeaderMenu,
    } = this.props; // TODO: 加入hideHeaderMenu是为了兼容无需登陆的工厂模式

    return (
      <>
        <Layout.Header
          theme={theme}
          className={cx('ice-design-layout-header', className)}
          style={{ ...style, width }}
        >
          <Logo />
          <div className="ice-design-layout-header-menu" style={{ display: 'flex' }}>
            {/* Header 菜单项 begin */}
            <Menu mode="horizontal" selectedKeys={[]}>
              {!isMobile && getAuthority().includes(Auths.BI) && !getProfile().lite ? (
                <Menu.Item>
                  <Link to="/bi">
                    <FoundationSymbol type="chart" size="small" />
                    {formatMessage('bi.header.fullscreen')}
                  </Link>
                </Menu.Item>
              ) : null}
              {
                // TODO: 后期优化显示不同图标和文字，并加入对IE的支持（目前IE全面屏显示不全并且无法退出）
                !isIE() && (
                  <Menu.Item>
                    <span onClick={() => toggleFullScreen()}>
                      <FoundationSymbol type="float-full" size="small" />{' '}
                      {!isMobile && formatMessage('menu.header.fullscreen.toggle')}
                    </span>
                  </Menu.Item>
                )
              }

              {
                // 钥匙授权
                getProfile().lite && (
                  <AuthMenuItem key="authKey" auth={Auths.authKEY}>
                    <span
                      onClick={() => {
                        console.log(sdkInfo);
                        if (!sdkInfo.sdk.registration) {
                          Feedback.toast.error(formatMessage('hardware.socket.disconnected'));
                          return;
                        }
                        if (!sdkInfo.reader.connection) {
                          Feedback.toast.error(formatMessage('hardware.wm.4097'));
                          return;
                        }
                        this.props.onAuthKey();
                      }}
                    >
                      <Suspense fallback={null}>
                        <FaKey size="12" style={{ marginRight: 8 }} />{' '}
                      </Suspense>
                      {formatMessage('key.authority.title')}
                    </span>
                  </AuthMenuItem>
                )
              }

              {!hideHeaderMenu &&
                this.headerMenuConfig &&
                this.headerMenuConfig.length > 0 &&
                this.headerMenuConfig.map((nav, idx) => {
                  const linkProps = {};
                  if (nav.newWindow) {
                    linkProps.href = nav.path;
                    linkProps.target = '_blank';
                  } else if (nav.external) {
                    linkProps.href = nav.path;
                  } else {
                    linkProps.to = nav.path;
                  }

                  const item =
                    nav.hideMobile && isMobile ? null : linkProps.to ? (
                      <Link {...linkProps}>
                        {nav.icon ? <FoundationSymbol type={nav.icon} size="small" /> : null}
                        {!isMobile ? nav.name : null}
                      </Link>
                    ) : (
                      <a {...linkProps}>
                        {nav.icon ? <FoundationSymbol type={nav.icon} size="small" /> : null}
                        {!isMobile ? nav.name : null}
                      </a>
                    );
                  return (
                    <AuthMenuItem key={idx} auth={nav.authority}>
                      {item}
                    </AuthMenuItem>
                  );
                })}
              {/* TODO: 移动端下直接隐藏这个item; */}
              {!isMobile && getAuthority().includes(Auths.DASHBOARD) ? (
                <Menu.Item>
                  <Balloon
                    closable={false}
                    // 加入位置自动调整防止全屏模式工厂布局下气泡显示不完整
                    needAdjust
                    trigger={
                      <Link
                        to="/sdk"
                        // style={{
                        //   display: 'flex',
                        //   alignItems: 'center',
                        //   fontSize: 12,
                        //   color: 'white',
                        // }}
                      >
                        <FoundationSymbol type="link" size="small" />
                        {formatMessage('menu.header.communication.status')}
                        {sdkInfo.sdk.connection &&
                        sdkInfo.sdk.registration &&
                        sdkInfo.reader.connection ? null : (
                          // TODO: 是否加入闪烁效果或者各种状态颜色？
                          // 显示徽章还不改变原有连接颜色的小技巧
                          <Badge dot>&nbsp;</Badge>
                        )}
                      </Link>
                    }
                  >
                    {this.renderSDKDialog()}
                  </Balloon>
                </Menu.Item>
              ) : null}
            </Menu>

            {/* Header 菜单项 end */}

            {/* Header 右侧内容块 */}
            {!hideHeaderMenu && (
              <Balloon
                trigger={
                  <div
                    className="ice-design-header-userpannel header-user-panel"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      fontSize: 12,
                    }}
                  >
                    {/* 已支持0时badge自动隐藏 */}
                    <Badge count={messagesInfo.authcount} style={styles.avatarBadge}>
                      <IceImg
                        height={40}
                        width={40}
                        // TODO: profile.avatar正常是以/avatar/*.png，这样拼接会多一个斜线;
                        // src={`${serverUrl}/${profileInfo.avatar || 'avatar/default.png'}`}
                        // 头像名称保证唯一时，更新头像后，由于img组件src未变，浏览器认为没有更新图片，并未加载新头像
                        // 为了使浏览器重新加载，加入一些无意义但不影响链接的后缀，使其更新图片
                        src={
                          profileInfo.avatar
                            ? `${profileInfo.avatar}?time=${new Date().getTime()}`
                            : 'avatar/default.png'
                        }
                        className="user-avatar"
                      />
                    </Badge>

                    {!isMobile && (
                      <div className="user-profile">
                        <div
                          className="user-name"
                          style={{ fontSize: '13px', ...styles.mayLongText }}
                        >
                          {isGuest() ? formatMessage('guest') : profileInfo.realname}
                        </div>
                        {isGuest() || (
                          <div
                            className="user-department"
                            style={{
                              fontSize: '12px',
                              color: '#999',
                              ...styles.mayLongText,
                            }}
                          >
                            {profileInfo.dept
                              ? profileInfo.dept.deptname
                              : formatMessage('menu.header.superdept')}
                          </div>
                        )}
                      </div>
                    )}
                    <Icon type="arrow-down-filling" size="xxs" className="icon-down" />
                  </div>
                }
                closable={false}
                className="user-profile-menu"
              >
                <ul>
                  <UserItem
                    to={getAuthority().includes(Auths.ADMINISTRATOR) ? '/company' : '/'}
                    icon={<FoundationSymbol type="home2" size="small" />}
                    title={formatMessage('menu.header.home')}
                  />
                  <AuthUserItem
                    // 由于权限检查组件目前不适用于多个权限组合认证，所有目前先使用bool认证方式
                    // auth={getAuthority().includes(Auths.USER) && getAuthority().includes(Auths.editKEY) && getAuthority().includes(Auths.queryKEY_OUTIN)}
                    auth={
                      getAuthority().includes(Auths.USER) &&
                      (!isAdvancedTask()
                        ? getAuthority().includes(Auths.auditKEY) &&
                          getAuthority().includes(Auths.queryKEY_OUTIN)
                        : getAuthority().includes(Auths.auditTASK))
                    }
                    // 存在待审批时，跳转到页面并筛选待审核，否则跳转到页面并不加入筛选条件
                    // TODO: 如果当前已经在领出页面时，点击跳转是无效的，也就没有办法进行筛选待审核;
                    to={{
                      pathname: isAdvancedTask() ? '/task/list' : '/record/key/outin',
                      state: messagesInfo.authcount ? { authed: 0 } : null,
                    }}
                    icon={<FoundationSymbol type="anchor" size="small" />}
                    extra={<Badge count={messagesInfo.authcount} style={styles.approvalBadge} />}
                    title={formatMessage('record.keyoutin.my.approval')}
                  />
                  <AuthUserItem
                    auth={Auths.USER}
                    to="/profile"
                    icon={<FoundationSymbol type="person" size="small" />}
                    title={formatMessage('menu.header.personal.setting')}
                  />
                  <AuthUserItem
                    auth={Auths.SUPER}
                    // 多企业版本
                    to="/system"
                    icon={<FoundationSymbol type="repair" size="small" />}
                    title={formatMessage('menu.header.system.setting')}
                  />
                  <UserItem
                    color="#5485F7"
                    icon={<FoundationSymbol type="question2" size="small" />}
                    title={formatMessage('menu.header.about')}
                    onClick={onShowAbout}
                  />
                  <UserItem
                    color={isGuest() ? '#bdbdbd' : '#ea7874'}
                    icon={<FoundationSymbol type="compass" size="small" />}
                    title={isGuest() ? formatMessage('login') : formatMessage('menu.header.logout')}
                    onClick={onLogout}
                  />
                </ul>
              </Balloon>
            )}
          </div>
        </Layout.Header>
        <KeyConnector
          ref={com => {
            this.keyconnector = com;
          }}
          closeAfterRead={false}
        />
      </>
    );
  }

  renderSDKDialog() {
    const { sdk, reader } = this.props.sdkInfo;
    const { hideHeaderMenu, commVersion, commUpdater, onCommUpdaterChange } = this.props;
    return (
      <div style={styles.sdkContainer}>
        {!!commVersion && (
          <div style={styles.version}>
            <div style={styles.versionText}>{commVersion}</div>
            <div style={styles.versionOperations}>
              <AuthCommItem
                auth={!isMulti() && getAuthority().includes(Auths.SUPER)}
                title={formatMessage('system.comm')}
                color={Colors.warning}
                href="#/system/commprogram"
              >
                <Suspense fallback={null}>
                  <FaChevronRight />
                </Suspense>
              </AuthCommItem>
              <CommItem title={formatMessage('system.comm.update.remind')}>
                <Switch
                  checked={commUpdater}
                  onChange={onCommUpdaterChange}
                  size="small"
                  className="switch-very-small"
                />
              </CommItem>
            </div>
          </div>
        )}

        <SdkItem
          prefixIcon={
            <Suspense fallback={null}>
              <FaPlug />
            </Suspense>
          }
          title={formatMessage('menu.header.communication.program')}
          suffixText={
            sdk.registration
              ? formatMessage('menu.header.communication.normal')
              : sdk.connection
              ? formatMessage('menu.header.communication.unregister')
              : formatMessage('menu.header.communication.disconnect')
          }
          // /* TODO: 颜色需不需要封装一下 */
          suffixColor={sdk.registration ? '#2eca9c' : sdk.connection ? '#f7c244' : '#ea7874'}
        />
        <SdkItem
          prefixIcon={
            <Suspense fallback={null}>
              <FaToolbox />
            </Suspense>
          }
          title={formatMessage(
            isWMSdk() ? 'menu.header.communication.key' : 'menu.header.communication.reader'
          )}
          suffixText={
            reader.connection
              ? formatMessage('menu.header.communication.normal')
              : formatMessage('menu.header.communication.disconnect')
          }
          suffixColor={reader.connection ? '#2eca9c' : '#ea7874'}
        />
        <div style={styles.sdkMore}>
          {
            // TODO: 后端支持下载各个系统的通讯组件后，条件处理一下
            // WM支持所有系统通讯
            // HM支持WIndows通讯
            isWMSdk() || isWindows() ? (
              <div>
                {/* TODO: 替换为Link 或者在layout页面进行命令跳转 */}
                {!hideHeaderMenu && (
                  <a href="#/sdk">{formatMessage('menu.header.communication.detail')}</a>
                )}
                {!sdk.connection ? (
                  <div>
                    <div style={styles.sdkDivider} />
                    <Button size="small" onClick={this.props.onGetSocketService}>
                      {formatMessage('menu.header.communication.download.program')}
                    </Button>
                  </div>
                ) : // TODO: 这边是否需要发卡器状态也正常的情况下？
                sdk.registration && getAuthority().includes(Auths.readKEY) ? (
                  <div>
                    <div style={styles.sdkDivider} />
                    <Button size="small" onClick={this.props.onReadKey}>
                      {formatMessage('menu.header.communication.readkey')}
                    </Button>
                  </div>
                ) : null}
              </div>
            ) : (
              <a style={styles.unsupportedOS}>
                {formatMessage('menu.header.communication.unsupport.system')}
              </a>
            )
          }
        </div>
      </div>
    );
  }
}

function SdkItem(props) {
  const { prefixIcon, title, suffixText, suffixColor } = props;
  return (
    // 为了支持IE10的flexbox;
    <div style={styles.sdkItem} className="header-sdk-item">
      <div style={styles.sdkTitle}>
        {prefixIcon}&nbsp;&nbsp;{title}
      </div>
      {/* TODO: 字体小于10px后没有效果？ */}
      <div style={{ ...styles.sdkBadge, backgroundColor: suffixColor }}>{suffixText}</div>
    </div>
  );
}

function UserItem(props) {
  const { to, title, icon, onClick, color, extra } = props;
  return (
    <li className="user-profile-menu-item" onClick={onClick}>
      {to ? (
        <Link to={to}>
          {icon}
          {title} {extra}
        </Link>
      ) : (
        <a style={{ color }}>
          {icon}
          {title} {extra}
        </a>
      )}
    </li>
  );
}

function CommItem({ title, children, width, color = '#bdbdbd', href }) {
  return (
    <a href={href} style={{ ...styles.commItem, width, color }}>
      <span>{title}&nbsp;&nbsp;</span>
      {children}
    </a>
  );
}

function toggleFullScreen() {
  // const el=e.srcElement||e.target;//target兼容Firefox
  const el = document.documentElement;
  const isFullscreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
  if (!isFullscreen) {
    // 进入全屏,多重短路表达式
    // eslint-disable-next-line no-unused-expressions
    (el.requestFullscreen && el.requestFullscreen()) ||
      (el.mozRequestFullScreen && el.mozRequestFullScreen()) ||
      (el.webkitRequestFullscreen && el.webkitRequestFullscreen()) ||
      (el.msRequestFullscreen && el.msRequestFullscreen());
  } else {
    // 退出全屏,三目运算符
    // eslint-disable-next-line no-unused-expressions
    document.exitFullscreen
      ? document.exitFullscreen()
      : document.mozCancelFullScreen
      ? document.mozCancelFullScreen()
      : document.webkitExitFullscreen
      ? document.webkitExitFullscreen()
      : '';
  }
}

const styles = {
  mayLongText: {
    maxWidth: '120px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  sdkContainer: {
    padding: '0px 0px',
    width: 220,
  },
  sdkItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '5px 0px',
  },
  sdkTitle: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '13px',
    marginRight: '20px',
  },
  sdkBadge: {
    padding: '3px 5px',
    color: 'white',
    borderRadius: '8px',
    // chrome内最小字体为12px
    fontSize: '12px',
    // 使用css3特性transform强制缩小字体
    transform: 'scale(0.8)',
  },
  sdkMore: {
    textAlign: 'center',
    fontSize: '13px',
    marginTop: '20px',
  },
  sdkDivider: {
    width: '100%',
    // TODO: 0.5px在IE10中无效
    height: '0.5px',
    backgroundColor: '#bdbdbd',
    margin: '8px 2px',
  },
  unsupportedOS: {
    color: Colors.error,
    fontSize: 12,
    borderWidth: 0.8,
    borderColor: Colors.error,
    borderStyle: 'solid',
    borderRadius: 8,
    padding: '5px 8px',
  },
  approvalBadge: {
    // chrome内最小字体为12px
    fontSize: '12px',
    // 使用css3特性transform强制缩小字体
    // transform: 'scale(0.8)',
    marginBottom: 1.5,
    position: 'absolute',
    right: -20,
    top: '50%',
    transform: 'scale(0.8) translateY(-70%)',
  },
  avatarBadge: {
    marginLeft: -10,
  },
  version: {
    marginBottom: 18,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  versionText: {
    fontWeight: 'bold',
    color: Colors.warning,
    fontSize: 15,
  },
  versionOperations: {
    display: 'flex',
    flexDirection: 'column',
  },
  commItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 6,
    textDecoration: 'none',
  },
};
